import { modal } from '@/src/utils/Modal';
import { get, isArray } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import { useI18n } from 'src/hooks/useRouterChange';
import { useWebSocket } from 'src/hooks/useWebSocket';
import { getUserInfo } from 'src/tools/getUserInfo';
import { generatorAuth } from 'src/tools/helper';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { salesChannelRoutes } from 'src/tools/urlMap';
import { EnumSalesChannelContentCategory } from 'src/types/common/resources';
import { EnumEvent } from 'src/types/common/ws';

const dict = {
  [salesChannelRoutes.salesChannelEditorHomepage]:
    EnumSalesChannelContentCategory.SalesChannelEditorHomepage,
  [salesChannelRoutes.salesChannelEditor404Page]:
    EnumSalesChannelContentCategory.SalesChannelEditor404Page,
  [salesChannelRoutes.salesChannelEditorProductSearch]:
    EnumSalesChannelContentCategory.SalesChannelEditorProductSearch,
  [salesChannelRoutes.salesChannelEditorContentPageList]:
    EnumSalesChannelContentCategory.SalesChannelEditorContentPageList,
  [salesChannelRoutes.salesChannelContentPageEditorPage]:
    EnumSalesChannelContentCategory.SalesChannelContentPageEditorPage,
  [salesChannelRoutes.salesChannelEditorTabbar]:
    EnumSalesChannelContentCategory.SalesChannelEditorTabbar,
  [salesChannelRoutes.salesChannelEditorShoppingCartPage]:
    EnumSalesChannelContentCategory.SalesChannelEditorShoppingCartPage,
  [salesChannelRoutes.salesChannelEditorPromotion]:
    EnumSalesChannelContentCategory.SalesChannelEditorPromotion,
  [salesChannelRoutes.salesChannelEditorProfilePage]:
    EnumSalesChannelContentCategory.SalesChannelEditorProfilePage,
  [salesChannelRoutes.salesChannelEditorAllProductPage]:
    EnumSalesChannelContentCategory.SalesChannelEditorAllProductPage,
  [salesChannelRoutes.salesChannelAppearanceEditorPage]:
    EnumSalesChannelContentCategory.SalesChannelAppearanceEditorPage,
  [salesChannelRoutes.salesChannelEditorNavigation]:
    EnumSalesChannelContentCategory.SalesChannelEditorNavigation,
  [salesChannelRoutes.salesChannelEditorHeader]:
    EnumSalesChannelContentCategory.SalesChannelEditorHeader,
  [salesChannelRoutes.salesChannelEditorFooter]:
    EnumSalesChannelContentCategory.SalesChannelEditorFooter,
  [salesChannelRoutes.salesChannelEditorMegaMenu]:
    EnumSalesChannelContentCategory.SalesChannelEditorMegaMenu,
  [salesChannelRoutes.salesChannelEditorAnimation]:
    EnumSalesChannelContentCategory.SalesChannelEditorAnimation,
  [salesChannelRoutes.salesChannelEditorButton]:
    EnumSalesChannelContentCategory.SalesChannelEditorButton,
  [salesChannelRoutes.salesChannelEditorText]:
    EnumSalesChannelContentCategory.SalesChannelEditorText,
};

const useSalesChannelEditorWs = () => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const p = useParams();
  const heartBeat = useRef<any>(null);
  const usrInfo = getUserInfo();
  const { userUuid, userName, loginName } = usrInfo;
  const _sUuid = get(p, 'saleChannelUuid');
  const currentPage = useRef<any>(null);
  const [pageEditors, setPageEditors] = useState([]);
  //const [currentMsgReceived, setCurrentMsgReceived] = React.useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);

  const countRef = useRef<number>(0);
  const isOtherEditing =
    (pageEditors || []).filter((i) => i.userId !== userUuid).length > 0;

  const handleOnMessage = (message) => {
    countRef.current = countRef.current + 1;
    try {
      const msg = JSON.parse(message.data);
      if (isArray(msg)) {
        setPageEditors(msg);
      } else {
        setPageEditors([]);
      }
    } catch (e) {
      console.error(e);
    }
    // console.log('message', message, JSON.parse(message.data));
    // setPageEditors(message);
  };
  const handleOnError = (error) => {
    console.error('err', error);
    setIsError(true);
  };

  const handleOnOpen = () => {
    const ping = {
      action: 'event',
      data: {
        eventName: EnumEvent.ping,
        data: {
          token: generatorAuth(),
          salesChannelUuid: _sUuid,
          page: page,
        },
      },
    };
    heartBeat.current = setInterval(() => {
      send(JSON.stringify(ping));
    }, 1000 * 60 * 5);
  };

  const handleOnClose = () => {
    if (heartBeat.current) {
      clearInterval(heartBeat.current);
    }
    // try {
    //   const d = JSON.stringify(generateData(EnumEvent.DISCONNECT, page));
    //   send(d);
    //   close();
    // } catch (e) {
    //   console.error(e);
    // }
  };
  // try{}catch(e){}
  const {
    send,
    isConnected,
    isClosed, //close
    isConnecting,
  } = useWebSocket({
    onMessage: handleOnMessage,
    onError: handleOnError,
    onOpen: handleOnOpen,
    onClose: handleOnClose,
  });
  const { path } = useRouteMatch();
  const page = dict[path];

  const handleOnEdit = () => {
    if (!isClicked) {
      const d = generateData(EnumEvent.EDIT, page);
      send(JSON.stringify(d));
      setIsClicked(true);
    }
  };

  const handleOnContentClick = (e) => {
    const usrs = pageEditors.reduce((pre, now) => {
      const { contactInfo, userName } = now;
      return `${pre ? `${pre},` : pre} ${userName}${
        contactInfo ? `(${contactInfo})` : ''
      } `;
    }, '');
    if (!isError) {
      e.preventDefault();
      e.stopPropagation();
      modal.error({
        title: getI18n('general.reminder'),
        content: replaceI18nVariables(getI18n('general.otherEditing'), usrs),
        onCancelText: getI18n('general.continue'),
        onCancel: () => {
          handleOnEdit();
          //setIsClicked(true);
        },
      });
    }
  };

  const generateData = (
    eventT: EnumEvent,
    page: EnumSalesChannelContentCategory,
  ) => {
    return {
      action: 'event',
      data: {
        eventName: eventT,
        data: {
          auth: { userName, userUuid, contactInfo: loginName },
          salesChannelUuid: _sUuid,
          page: page,
        },
      },
    };
  };
  // useEffect(() => {}, [isOtherEditing]);
  useEffect(() => {
    setIsClicked(false);
    if (isConnected) {
      if (currentPage.current) {
        if (currentPage.current !== page) {
          const d = JSON.stringify(
            generateData(EnumEvent.DISCONNECT, currentPage.current),
          );
          send(d);
        }
      }
      const d = JSON.stringify(generateData(EnumEvent.ENTER, page));
      send(d);
    }
    currentPage.current = page;
  }, [page, isConnected]);

  return {
    onContentClick: handleOnContentClick,
    pageEditors,
    isConnected,
    isClicked,
    isOtherEditing,
    isClosed,
    onEdit: handleOnEdit,
    displaySpin: isConnecting,
  };
};

export { useSalesChannelEditorWs };
